export default "__VITE_ASSET__BiyaCZmN__"